// removed by extract-text-webpack-plugin
module.exports = {"container":"src-lib-components-__SubBar__container--32ljF","hasSidebar":"src-lib-components-__SubBar__hasSidebar--KY6Q5"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/SubBar.less
// module id = 1862
// module chunks = 0